import * as React from 'react';
import { cn } from 'lib/utils';

const HeadingRoot = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div {...props} className={cn('flex flex-col gap-2', className)} />;
};

const HeadingTitle = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div {...props} className={cn('text-[14px] font-semibold', className)} />;
};

const HeadingContent = ({ className, ...props }: React.ComponentProps<'div'>) => {
  return <div {...props} className={cn('flex items-center gap-2 text-2xl font-bold', className)} />;
};

export const Heading = Object.assign(HeadingRoot, {
  Title: HeadingTitle,
  Content: HeadingContent,
});